import type { Gifts } from '.';
import { PST_UTC_OFFSET } from 'src/replicant/utils/time';

export default (
  Gifts: Pick<Gifts, 'schema' | 'ruleset'>,
  { Inventory }: Gifts['$DEPENDENCIES'],
) => (state: Gifts.State) => ({
  /**
   * Check if we can send reward to this user
   */
  canSendGift: (targetUserId: string, now: number) => {
    // Check last sent gift for given user
    const gift = state.gifts.sent[targetUserId];

    // If gift was never sent, we can send gift to this user
    if (!gift) return true;

    // Calculate time to 00:00 JST of next day from sent date
    const endOfCooldown = new Date(gift.sentAt + PST_UTC_OFFSET);

    // One day ahead
    endOfCooldown.setUTCDate(endOfCooldown.getUTCDate() + 1);

    // Reset hours, minutes, seconds, and ms
    endOfCooldown.setUTCHours(0, 0, 0, 0);

    // If we passed over end of cooldown date we can send message again
    if (now + PST_UTC_OFFSET >= endOfCooldown.getTime()) return true;

    // False by default
    return false;
  },

  /**
   * Can collect reward from specific user
   */
  canCollect: (senderUserId: string, now: number) => {
    const gift = state.gifts.received[senderUserId];

    // No received gift - No reward
    if (!gift) return false;

    // Check if we didn't overflow max energy
    const energyNow = Inventory.getters(state).getEnergy(now);
    const total = energyNow + gift.energy;

    // If we have more energy then maxClaimEnergy do not allow claim new one
    if (total > Gifts.ruleset.maxClaimEnergy) return false;

    // All check passed we can collect
    return true;
  },

  /**
   * Check if gift exist, but doesn't not check if current user be able to collect it
   */
  hasGift: (senderUserId: string) => {
    return !!state.gifts.received[senderUserId];
  },

  /**
   * Get total energy available for collect
   */
  getEnergyRewardsTotal: (now: number) => {
    const gifts = state.gifts.received;
    const giftsUsersIds = Object.keys(state.gifts.received);
    const max = Gifts.ruleset.maxClaimEnergy;
    const current = Inventory.getters(state).getEnergy(now);

    const total = giftsUsersIds.reduce((acc, id) => {
      return gifts[id].energy + acc;
    }, 0);

    const diff = max - (current + total);
    const available = total + Math.min(0, diff);

    return Math.max(0, available);
  },
});
